import { Path } from "react-native-svg";
import CustomIcon, { CustomIconProps } from "./CustomIcon";

const ArrowRight: React.FC<CustomIconProps> = (props) => (
  <CustomIcon {...props}>
    <Path clipRule="evenodd" d="M12.6517 3.90167C12.1635 3.41352 11.3721 3.41352 10.8839 3.90167C10.3957 4.38983 10.3957 5.18128 10.8839 5.66944L14.0533 8.83882L2.92894 8.83882C2.23859 8.83882 1.67894 9.39847 1.67894 10.0888C1.67894 10.7792 2.23859 11.3388 2.92894 11.3388L14.0534 11.3388L10.8839 14.5083C10.3957 14.9964 10.3957 15.7879 10.8839 16.276C11.3721 16.7642 12.1635 16.7642 12.6517 16.276L17.955 10.9727C18.4431 10.4846 18.4431 9.69313 17.955 9.20497L12.6517 3.90167Z" fillRule="evenodd" /> 
  </CustomIcon>
);

export default ArrowRight;